import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import "./diagnostics_css.css";
import "./diagnostics_js.js";
import ServiceShowcase from "../ServiceShowCase.jsx";
import CardSlider from "../CardSlider.jsx";
import banner from "../../Assets/cover.png";
import ServicesGrid from "../ServiceGrid.jsx";
import CardsContainer from "../CardsContainer.jsx";
import Testimonials from "../../Testimonial/Testimonial.jsx";
import CoverHero from "../CoverHero.jsx";
import { useState } from "react";
import LoginModal from "../../Modals/LoginModal.js";
import {
  serviceShowcaseData,
  diagnostics_couch_data,
  Repertoireheading,
  RepertoireServices,
  functionServices,
  functionheading,
  chooseexcellence_data,
  edgeheading,
  edgeServices,
  benefitheading,
  benefitServices,
  diagnostics_testimonials,
} from "./diagnostics_js.js";
import { useNavigate } from "react-router-dom";

const Diagnostics = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <CoverHero image={banner} title="Diagnostics" />
      <div className="servicesShowCase">
        {serviceShowcaseData.map((service, index) => (
          <ServiceShowcase
            key={index}
            className="medical-equ ml-4"
            data={service}
            onServiceClick={() => navigate('/')}
          />
        ))}
      </div>

      <div className="choose-excellence m40">
        <h2 className="excellence-title">{diagnostics_couch_data.title}</h2>
        <div className="excellence-content">
          <div className="icu-image-container">
            <p>{diagnostics_couch_data.para1}</p>
            <p>{diagnostics_couch_data.para2}</p>
          </div>

          <div className="image-container">
            <img
              src={diagnostics_couch_data.image}
              alt={diagnostics_couch_data.title}
            />
          </div>
        </div>
      </div>

      <CardsContainer
        heading={Repertoireheading}
        services={Object.values(RepertoireServices)}
        className="white-bg"
      />
      <CardsContainer
        heading={functionheading}
        services={Object.values(functionServices)}
      />
      <div className="choose-excellence white-bg">
        <div className="excellence-content">
          <div className="blend-container">
            <h2 className="excellence-title second-title">
              {chooseexcellence_data.title}
            </h2>
            <h3 className="subtitle-h3">{chooseexcellence_data.subheading}</h3>
            <p>{chooseexcellence_data.para1}</p>
            <p>{chooseexcellence_data.para2}</p>
          </div>

          <div className="image-container">
            <img
              src={chooseexcellence_data.image}
              alt={chooseexcellence_data.title}
            />
          </div>
        </div>
      </div>

      <CardsContainer
        heading={edgeheading}
        services={Object.values(edgeServices)}
      />
      <CardsContainer
        heading={benefitheading}
        services={Object.values(benefitServices)}
        className="white-bg"
      />

      <div className="excellence-testimonials-container">
        <Testimonials
          data={diagnostics_testimonials}
          textKey="desc"
          imgKey="userimg"
          nameKey="username"
          className="grey-bg"
        />
      </div>
      <ServicesGrid
        className="bg-white"
        title="Check Our Other Services"
        exclude="Diagnostics"
      />
      <Footer />
    </>
  );
};

export default Diagnostics;
